import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";

function TopInformation(props) {
	const [info, setInfo] = useState([]);
	const [infoURL, setInfoURL] = useState([]);
	
	const { t } = useTranslation();

	//TODO レンダリング回数を軽減すること
	useEffect(() => {
		if(props.topics && props.language) {
			setTopInformation();
		}
	});

	const setTopInformation = () => {
		//URLと文言をセット
		if (props.topics) {
			if (props.language === 'ja_JP') {
				setInfo(props.topics.topic_jp);
			}
			else {
				setInfo(props.topics.topic_en);
			}
			if (t("topInformation.allViewURL") != '' ) {
				setInfoURL(t("topInformation.allViewURL"));
			}
			else {
				setInfoURL('');
			}
		}
	}

	return (
		<div className="information">
			<div className="information__inner">
				<div className="information__title">{t("topInformation.title")}</div>
				<ul className="information__items">
					{info.map( ( _line, index) => {
						return (
							<li className="information__item" key={index}>
								<a className="information__item-link" href={_line.url} target="_blank" rel="noreferrer">{_line.text}</a>
							</li>
						)
					})}
				</ul>
				{infoURL && (
					<a className="information__more-button" href={infoURL} target="_blank" rel="noreferrer">{t("topInformation.allViewBtn")}</a>
				)}
			</div>
		</div>
	)
}

export default TopInformation;
